// Storage utility functions
const storageUtils = {
    // Clear all storage for specific path/application
    clearAppStorage: () => {
      // Get all localStorage keys
      const keys = Object.keys(localStorage);
      
      // Clear only keys related to your application
      keys.forEach(key => {
        if (key.startsWith('persist:') || // Clear Redux persist data
            key.startsWith('knowledge_') || // Clear app-specific data (add your prefix)
            key === 'persist:auth' || // Clear auth specifically
            key === 'persist:root') { // Clear root persist data
          localStorage.removeItem(key);
        }
      });
  
      // Clear session storage similarly
      const sessionKeys = Object.keys(sessionStorage);
      sessionKeys.forEach(key => {
        if (key.startsWith('knowledge_') || // Clear app-specific data
            key.startsWith('persist:')) {
          sessionStorage.removeItem(key);
        }
      });
    },
  
    // Clear specific auth-related storage
    clearAuthStorage: () => {
      localStorage.removeItem('persist:auth');
      sessionStorage.removeItem('knowledge_user');
    },
  
    // Clear all cookies for your domain path
    clearCookies: () => {
      const pathToMatch = '/knowledge'; // Your application path
      document.cookie.split(';').forEach(cookie => {
        const [name] = cookie.split('=');
        document.cookie = `${name}=;expires=${new Date(0).toUTCString()};path=${pathToMatch}`;
      });
    }
  };
  
  export default storageUtils;